import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select"

export default function SelectPeriodo({onChangeValue, value}) {

    
    
    return (
        <Select
        id="produtoId"
        onValueChange={(value) => onChangeValue(value)}
        value={value}
        defaultValue={'mensal'}
        required
    >
        <SelectTrigger className="w-[200px] text-secondary bg-darkaccent/70">
            <SelectValue />
        </SelectTrigger>
        <SelectContent>
            <SelectItem 
                value={"mensal"}
            >
                Mês
            </SelectItem>
            <SelectItem 
                value={"anual"}
            >
                Ano
            </SelectItem>
        </SelectContent>
    </Select>
    )
}